import React from 'react'
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import MoveToInboxRoundedIcon from '@mui/icons-material/MoveToInboxRounded';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { Link } from 'react-router-dom';

function calculatorJournal(a, b) {
  if (!a || !b) return 0;
  return Math.round((a / b) * 100);
}

function StatCard({ to, title, subtitle, value, percent, percentText, Icon, color }) {
  return (
    <Box
      component={Link}
      to={to}
      sx={{
        position: 'relative', overflow: 'hidden',
        display: 'flex', flexDirection: 'column', gap: 1.25,
        p: 2.25, borderRadius: 3,
        bgcolor: '#fff', border: '1px solid #e3e6ea',
        textDecoration: 'none', color: 'inherit',
        transition: 'transform .18s, box-shadow .18s, border-color .18s',
        '&:hover': {
          transform: 'translateY(-3px)',
          boxShadow: `0 12px 24px ${color}26`,
          borderColor: `${color}66`,
          '& .stat-arrow': { opacity: 1, transform: 'translateX(0)' },
        },
        // แถบสีด้านบน
        '&::before': {
          content: '""', position: 'absolute', top: 0, left: 0, right: 0, height: 4,
          background: `linear-gradient(90deg, ${color} 0%, ${color}80 100%)`,
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <Box sx={{
            width: 42, height: 42, borderRadius: 2.5,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            bgcolor: `${color}18`, color,
          }}>
            <Icon sx={{ fontSize: 24 }} />
          </Box>
          <Box sx={{ fontWeight: 700, fontSize: 15.5, color: '#263238' }}>{title}</Box>
        </Box>
        <ArrowForwardRoundedIcon className="stat-arrow" sx={{
          fontSize: 20, color, opacity: 0, transform: 'translateX(-6px)', transition: 'all .18s',
        }} />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
        <Box sx={{ fontSize: 34, fontWeight: 800, color: '#263238', lineHeight: 1 }}>{value}</Box>
        <Box sx={{ fontSize: 13, color: '#90a4ae' }}>เอกสาร</Box>
      </Box>
      <Box sx={{ fontSize: 12.5, color: '#78909c', mt: -0.5 }}>{subtitle}</Box>

      <Box>
        <LinearProgress
          variant="determinate"
          value={Math.min(percent, 100)}
          sx={{ height: 6, borderRadius: 999, bgcolor: '#eef1f4', '& .MuiLinearProgress-bar': { borderRadius: 999, bgcolor: color } }}
        />
        <Box sx={{ mt: 0.75, fontSize: 12, color: '#90a4ae' }}>
          <Box component="span" sx={{ color, fontWeight: 700 }}>{percentText ?? `${percent}%`}</Box>
          {percentText ? '' : ' of total documents'}
        </Box>
      </Box>
    </Box>
  );
}

const CardWorkflow = (props) => {
  const isDraft = props.dataStateflow == 1;

  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
      gap: 2,
      width: '100%',
    }}>
      <StatCard
        to={`/ViewFlowProcess/1`}
        title="Total Documents"
        subtitle="All documents in workflow"
        value={props.countAll}
        percent={100}
        percentText="100% completion rate"
        Icon={DescriptionRoundedIcon}
        color="#455a64"
      />
      <StatCard
        to={`/ViewFlowProcess/2`}
        title="Preview"
        subtitle="Documents awaiting review"
        value={props.countInpreveiw}
        percent={calculatorJournal(props.countInpreveiw, props.countAll)}
        Icon={VisibilityRoundedIcon}
        color="#1e88e5"
      />
      <StatCard
        to={`/ViewFlowProcess/3`}
        title="Approved"
        subtitle="Successfully approved"
        value={props.countapproved}
        percent={calculatorJournal(props.countapproved, props.countAll)}
        Icon={TaskAltRoundedIcon}
        color="#43a047"
      />
      <StatCard
        to={`/ViewFlowProcess/4`}
        title={isDraft ? 'Draft' : 'Received'}
        subtitle={`Documents awaiting ${props.dataStateflow > 1 ? 'review' : 'draft'}`}
        value={props.countPading}
        percent={calculatorJournal(props.countPading, props.countAll)}
        Icon={isDraft ? EditNoteRoundedIcon : MoveToInboxRoundedIcon}
        color="#ef6c00"
      />
      <StatCard
        to={`/ViewFlowProcess/5`}
        title="Processed"
        subtitle="Documents fully processed"
        value={props.countSuccessfully}
        percent={calculatorJournal(props.countSuccessfully, props.countAll)}
        Icon={VerifiedRoundedIcon}
        color="#00897b"
      />
    </Box>
  )
}

export default CardWorkflow
